import { render, staticRenderFns } from "./ShowData.vue?vue&type=template&id=10ced8c4&"
import script from "./ShowData.vue?vue&type=script&lang=js&"
export * from "./ShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports